import { StepCard } from './StepCard';
import type { DraggableStepCardProps } from './DraggableStepCard';
import { StepCardOld } from './StepCardOld';

type TriggerCardProps = DraggableStepCardProps & {
  className?: string;
};

export default function TriggerCard({
  panel = null,
  addMenu = true,
  onSelectMenu,
  style,
  className,
  // Below props relate to dragging and we want to just ignore them
  scale,
  position,
  onStart,
  onStop,
  ...props
}: TriggerCardProps) {
  const CardComponent = props.isSmartConnectorFlow ? StepCardOld : StepCard;
  return (
    <CardComponent
      panel={panel}
      onSelectMenu={onSelectMenu}
      addMenu={addMenu}
      {...props}
    />
  );
}
